<template>
    <div class="container-fluid">
        <Breadcrumb title="Applied Configs" button-url="appliedPmtaConfigCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <div class="form-group">
                                    <small class="form-text text-muted mt-0">
                                        If the Version = 0, it means the Config has not yet been uploaded to the recipient.<br/>
                                        If the Version is reset, the Config will be uploaded to the recipient one more time.
                                    </small>
                                </div>
                            <button type="button" class="btn btn-info btn-rounded mr-2 mb-2" @click="bulkResetCurrentVersion()"
                                v-bind:disabled="!selectedAppliedConfigs.length">
                                <i class="far fa-sync"></i>
                                Reset version
                            </button>
                            <button type="button" class="btn btn-danger btn-rounded mr-2 mb-2" @click="bulkDelete()"
                                v-bind:disabled="!selectedAppliedConfigs.length">
                                <i class="far fa-trash-alt"></i>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group">
                                <treeselect placeholder="Search by type" v-model="filter.configType" :multiple="false"
                                    :options="typeList" :load-options="loadTypeList" />
                            </div>
                            <div class="input-group form-group">
                                <input v-model="filter.configName" type="text" class="form-control form-control-line"
                                    placeholder="Search by Config name">
                            </div>
                            <div class="input-group form-group mb-0">
                                <input v-model="filter.recipient" type="text" class="form-control form-control-line"
                                    placeholder="Search by Recipient(pmta name or relay host)">
                            </div>
                        </div>
                    </div>
                    <div class="form-inline col-12">
                        <div class="form-group col-2 mb-2">
                            <span>Total:
                                <span class="label label-info">{{ totalItems }}</span>
                            </span>
                        </div>
                        <div class="form-group col-2 mb-2 ml-auto mr-3">
                            <button class="btn btn-info text-uppercase waves-effect waves-light w-100" @click="search">
                                Search
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{ preloader: loading }"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="appliedConfigList.length > 0">
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th><input type="checkbox" v-model="selectAllAppliedConfigs" @click="selectAll()">
                                                    </th>
                                                    <th @click="tableOrdering('configType')">
                                                        <span role='button'>Type</span>
                                                    </th>
                                                    <th @click="tableOrdering('configName')">
                                                        <span role='button'>Name</span>
                                                    </th>
                                                    <th @click="tableOrdering('recipient')">
                                                        <span role='button'>Recipient</span>
                                                    </th>
                                                    <th @click="tableOrdering('version')">
                                                        <span role='button'>Version</span>
                                                    </th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(appliedConfig, index) in appliedConfigList" :key="index">
                                                    <td class="align-middle">
                                                        <input type="checkbox" v-model="selectedAppliedConfigs"
                                                            :value="{'appliedConfigId': appliedConfig.id, 'appliedConfigType': appliedConfig.configType}">
                                                    </td>
                                                    <td class="align-middle">
                                                        {{ (typeList.find(type => type['id'] ===
                                                            appliedConfig.configType).label) }}
                                                    </td>
                                                    <td class="align-middle">{{ appliedConfig.configName }}</td>
                                                    <td class="align-middle">{{ appliedConfig.recipient }}</td>
                                                    <td class="align-middle">{{ appliedConfig.version }}</td>
                                                    <td class="align-middle">
                                                        <button type="button" class="btn btn-sm btn-info m-r-10"
                                                            @click="resetCurrentVersion([{ 'appliedConfigId': appliedConfig.id, 'appliedConfigType': appliedConfig.configType }])">
                                                            <i class="fa fa-minus-circle"></i> Reset Version
                                                        </button>
                                                        <button type="button" class="btn btn-sm btn-danger"
                                                            @click="deleteAppliedConfig([{ 'appliedConfigId': appliedConfig.id, 'appliedConfigType': appliedConfig.configType }])">
                                                            <i class="fa fa-minus-circle"></i> Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Swal from 'sweetalert2';
import PmtaConfigService from '../services/PmtaConfigService';
import Preloader from '../components/Preloader';
import Breadcrumb from '../components/Breadcrumb';
import Treeselect from '@riophae/vue-treeselect';

export default {
    name: 'AppliedPmtaConfigs',
    components: {
        Preloader, Breadcrumb, Treeselect
    },
    data() {
        return {
            isAdmin: this.$store.getters.isAdmin,
            appliedConfigList: [],
            filter: {
                configType: null,
                configName: null,
                recipient: null
            },
            order: {
                field: "configType",
                asc: true
            },
            selectedAppliedConfigs: [],
            selectAllAppliedConfigs: false,
            typeList: null,
            loading: false,
            totalItems: 0,
        }
    },
    mounted() {
        this.getItems();
    },
    methods: {
        getItems: function () {
            this.loading = true;
            PmtaConfigService.getAppliedConfigs(
                this.filter,
                this.order
            ).then(response => {
                this.appliedConfigList = response.data.list;
                this.totalItems = response.data.list.length;
                this.loading = false;
            });
        },
        search: function () {
            this.getItems();
        },
        tableOrdering(field) {
            if (this.order.field === field) {
                this.order.asc = (this.order.asc === true) ? false : true;
            } else {
                this.order.field = field;
                this.order.asc = true;
            }
            this.getItems();
        },
        deleteAppliedConfig(ids) {
            Swal({
                title: 'Are you sure you want to delete?',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaConfigService.deleteAppliedConfigs(ids).then((response) => {
                        if (response.status === 204) {
                            this.getItems();
                        } else {
                            Swal.showValidationMessage(
                                `Delete failed: ${response.data.error}`
                            );
                            return false;
                        }
                    }).catch(error => {
                        Swal.showValidationMessage(
                            'Error: ' + error.response.data.error[0]
                        )
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    Swal(
                        'Deleted successfully!',
                        `Pmta Config File has been deleted.`,
                        'success'
                    )
                }
            })
        },
        bulkDelete() {
            this.deleteAppliedConfig(this.selectedAppliedConfigs);
            this.selectedAppliedConfigs = []
        },
        loadTypeList({ callback }) {
            PmtaConfigService.getTypeList().then(response => {
                this.typeList = response.data.types.map((type, index) => {
                    return { id: index, label: type }
                });
                callback();
            });
        },
        resetCurrentVersion(ids) {
            Swal({
                title: 'Are you sure you want to reset current version?',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaConfigService.resetCurrentVersion(ids).then((response) => {
                        if (response.status === 200) {
                            this.getItems();
                        } else {
                            Swal.showValidationMessage(
                                `Reset failed: ${response.data.error}`
                            );
                            return false;
                        }
                    }).catch(error => {
                        Swal.showValidationMessage(
                            'Error: ' + error.response.data.error[0]
                        )
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    Swal(
                        'Reset successfully!',
                        `Current version has been reseted.`,
                        'success'
                    )
                }
            })
        },
        bulkResetCurrentVersion() {
            this.resetCurrentVersion(this.selectedAppliedConfigs);
            this.selectedAppliedConfigs = []
        },
        selectAll() {
            this.selectedAppliedConfigs = [];
            if (!this.selectAllAppliedConfigs) {
                for (let appliedConfig of this.appliedConfigList) {
                    this.selectedAppliedConfigs.push({'appliedConfigId': appliedConfig.id, 'appliedConfigType': appliedConfig.configType});
                }
            }
        },
    },
}
</script>

<style scoped></style>